<script>
import Vue from "vue";
import { CRadio } from "@chakra-ui/vue";

export default Vue.component("OmtRadio", {
  props: {
    value: String,
    reverse: {
      type: Boolean,
      default: false
    },
    navyBlue: {
      type: Boolean,
      default: false
    }
  },
  render(createElement) {
    return createElement(
      CRadio,
      {
        nativeOn: {
          change: () => {
            this.$emit("click", this.value);
          }
        },
        class: `omt-radio ${this.reverse ? "omt-radio--reverse" : ""} ${this.navyBlue ? "omt-radio--navy-blue" : ""}`,
        attrs: {
          ...this.$attrs
        }
      },
      this.$slots.default
    );
  }
});
</script>

<style scoped>
::v-deep.omt-radio div[data-chakra-component="CBox"] {
  margin-left: 0;
}

::v-deep.omt-radio input[type="radio"]:checked + div {
  background: white;
}

::v-deep.omt-radio input[type="radio"]:checked + div span {
  background: var(--colors-light-primary-gray1);
  height: 57%;
  width: 57%;
}

::v-deep.omt-radio input[type="radio"] + div {
  background: white;
  border-color: var(--colors-light-primary-gray1);
}

::v-deep.omt-radio {
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
}

/* Variação reversa: radio primeiro, label depois, alinhado à esquerda */
::v-deep.omt-radio--reverse {
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: auto;
}

::v-deep.omt-radio--reverse div[data-chakra-component="CBox"] {
  margin-left: 8px;
  margin-right: 0;
}

/* Variação navy-blue: cor da bolinha e borda em navy-blue */
::v-deep.omt-radio--navy-blue input[type="radio"]:checked + div span {
  background: var(--colors-light-primary-navy-blue);
}

::v-deep.omt-radio--navy-blue input[type="radio"] + div {
  border-color: var(--colors-light-primary-navy-blue);
}
</style>
